(() => {
  if (window.location.host == '127.0.0.1:9292' ) {
    webworker_url = webworker_url.replace(`//${Shopify.shop}`, 'http://127.0.0.1:9292');
  }
  const WORKER = new Worker(webworker_url);

  let fabric_swatches = [];
  let fabric_load_started = false;

  // Defer loading until drawer opens to avoid competing with product images
  window.onload = () => {
    if (!fabric_load_started) {
      fabric_load_started = true;
      WORKER.postMessage({ type: 'load:fabric_swatches' });
    }
  };
  let fabric_swatches_by_group = [];

  GetSwatches = (res_swatches) => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(res_swatches, 'text/html');
    let $swatch = [...doc.querySelectorAll('.fabric-swatch')];
    let swatches = $swatch.map(swatch => {
      // preload image
      let img = new Image();
      img.src = swatch.dataset.image.replace('width=1', 'width=300');
      return {
        id: swatch.dataset.id,
        name: swatch.dataset.name,
        image: swatch.dataset.image,
        group: swatch.dataset.group,
        description: swatch.dataset.description,
        index_in_group: parseInt(swatch.dataset.index_in_group),
        selected: false
      }
    });
    return { 
      swatches,
      paginate: {
        next_page: doc.querySelector('paginate')?.dataset.nextpage
      }
    };
  }
  WORKER.onmessage = function (e) {
    if (e.data.type == 'loaded:fabric_swatches') {
      const res_swatches = e.data.data.res_swatches;
      let swatches = GetSwatches(res_swatches).swatches;
      let paginate = GetSwatches(res_swatches).paginate;
      // console.log('Swatches loaded from worker:', swatches, paginate);

      // if page is less than total pages, load next page
      if (paginate.next_page) {
        WORKER.postMessage({ 
          type: 'load:fabric_swatches', 
          page: paginate.next_page
        });
      }

      fabric_swatches = [...fabric_swatches, ...swatches];
      // group swatches by group as array of objects with group name and swatches in that group
      fabric_swatches_by_group = Object.values(fabric_swatches.reduce((groups, swatch) => {
        if (!groups[swatch.group]) {
          groups[swatch.group] = {
            name: swatch.group,
            swatches: []
          };
        }
        groups[swatch.group].swatches.push(swatch);
        return groups;
      }, {}));

      // Sort swatches in each group by index
      fabric_swatches_by_group.forEach(group => {
        group.swatches.sort((a, b) => a.index_in_group - b.index_in_group);
      });
      document.dispatchEvent(new CustomEvent('loaded:fabric_swatches', { detail: { fabric_swatches_by_group } }));
    }
  }
})();

document.addEventListener('alpine:init', () => {
  Alpine.data('FabricSelector', () => ({
    selected_swatch: null,
    flags: {
      show_error: false
    },    
    init() {
      document.body.classList.add('has-fabric-selector');

      this.MoveDrawerToBody();
      this.InitWatchers();
    },
    MoveDrawerToBody() {
      const drawer = this.$el.querySelector('#FabricsDrawer');
      if (drawer) {
        document.body.appendChild(drawer);
      }
    },
    InitWatchers() {
      document.addEventListener('fabric_swatch_selected', (e) => {
        this.selected_swatch = e.detail.swatch;
      });

      this.$watch('selected_swatch', (swatch) => {
        this.flags.show_error = !swatch;
        document.body.classList.toggle('fabric-selected', !!swatch);
      });
    }
  }));

  Alpine.data('FabricSwatch', (fabric_swatch) => ({
    fabric_swatch: fabric_swatch,
    tooltip_initialized: false,
    init() {
      this.InitTooltip();
      // when visible in viewport, update swatch image background to better resolution
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.UpdateSwatchImage();
          }
        });
      }, { threshold: 0.5 });
      this.observer.observe(this.$el);
    },
    UpdateSwatchImage() {
      this.$el.querySelector('fabric-swatch-image').style.backgroundImage = `url(${this.fabric_swatch.image.replace('width=1', 'width=300')})`;
    },
    InitTooltip() {
      if (this.tooltip_initialized) return;
      const tooltip_content = `
      <div class="fabric-tooltip" data-tooltip-content>
        <div class="fabric-tooltip__content">
          <fabric-swatch-image
            style="background-image: url(${fabric_swatch.image})}">
            <picture class="image-wrap">
              <source srcset="${fabric_swatch.image.replace('width=1', 'width=600')}" media="(min-width: 1024px)"> 
              <source srcset="${fabric_swatch.image.replace('width=1', 'width=300')}" media="(min-width: 300px)"> 
              <img src="${fabric_swatch.image.replace('width=1', 'width=150')}" 
                alt="${fabric_swatch.name}" 
                loading="lazy"
                height="50" width="50" />
            </picture>
          </fabric-swatch-image>

          <div>
            <p><strong>${fabric_swatch.name}</strong></p>
            <p>${fabric_swatch.description}</p>
          </div>
        </div>
      </div>
      `;

      const tooltip_config = {
        content: tooltip_content,
        allowHTML: true,
        maxWidth: 'max(40vw, 450px)',
        theme: 'light',
        delay: [300, null],
      };

      if (window.innerWidth < 600) {
        tooltip_config.trigger = 'click';
      }

      tippy(this.$el, tooltip_config);
      this.tooltip_initialized = true;
    }
  }));

  Alpine.data('FabricDrawer', () => ({
    fabric_swatches_by_group: [],
    selected_swatch: null,
    flags: {
      isOpen: false,
    },
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      this.$watch('flags.isOpen', (isOpen) => {
        const drawer = this.$el;
        drawer.setAttribute('aria-hidden', !isOpen);
        drawer.classList.toggle('open', isOpen);
        document.body.classList.toggle('fabric-drawer-open', isOpen);
      });

      // document event listener for opening the drawer
      document.addEventListener('open_fabric_drawer', () => {
        this.flags.isOpen = true;
      });

      // load fabric swatches from worker
      document.addEventListener('loaded:fabric_swatches', (e) => {
        this.fabric_swatches_by_group = e.detail.fabric_swatches_by_group;
        // console.log('Fabric swatches loaded in drawer:', e.detail.fabric_swatches_by_group);
      });

      this.$watch('selected_swatch', (swatch) => {
        document.dispatchEvent(new CustomEvent('fabric_swatch_selected', { detail: { swatch } }));
      });
    }
  }));
});